<template>
  <i class="icon_wrap"></i>
</template>

<script>
export default {
  name: 'go'
};
</script>

<style scoped lang="stylus">
.icon_wrap {
  display inline-block
  width 17px
  height 16px
  background-size 17px 16px
  background-repeat no-repeat
  background-position center
  background-image url('./images/h5_payment_icon_address_more@3x.png')
}
</style>
